<div>
    <div [ngSwitch]="headerMode">
        <div *ngSwitchCase="'normal'">
            <ng-container *ngIf="!readOnlyMode; else editMode;" #buttons>
                <button #buttons id="viewModeButton" (click)="headerButtonToggle('viewMode')">
                    <span>View</span>
                </button>
            </ng-container>

            <ng-template #editMode>
                <button #buttons id="editModeButton" (click)="headerButtonToggle('editMode')">
                    <span>Edit</span>
                </button>
            </ng-template>
        </div>
        <div *ngSwitchCase="'takeover'">
            <button #buttons id="takeoverModeButton" (click)="headerButtonToggle('editMode')">
                <span>Take Over</span>
            </button>
        </div>
    </div>
</div>
<div>
    <!-- TODO: fix refrence typo, should update when updating integration tests -->
    <p class="refrence-text">Application ID:</p>
    <h4 class="refrence-value">{{referenceId}}</h4>
</div>
<div *ngIf="getMessages?.length > 0" class="message-container">
    <mat-list *ngFor="let message of getMessages" class="mat-list mat-list-base messages">
        <mat-list-item class="mat-list-item mat-focus-indicator">
            <div class="message">
                <mat-icon matListItemIcon role="img"
                    class="message-icon mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="font">info_outline</mat-icon>
                <span matListItemLine>{{message.target}}</span>
            </div>
        </mat-list-item>
    </mat-list>
</div>
<div *ngIf="headerMode === 'locked'">
    <mat-card appearance="outlined" class="mat-card mat-focus-indicator locked">
        <div class="row text-center">
            <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true"
                data-mat-icon-type="font">lock</mat-icon>
        </div>
        <div class="row text-center"> Application Form is Locked.</div>
    </mat-card>
</div>